"use client";
import FlutterCarousel from "@/components/FlutterCarousel";
import { useState } from "react";
import { isFlutterItem } from "@/lib/flutter/contract";
import { getFlutterPresentation } from "@/lib/flutter/presentation";

function FlutterImage({ src, name, logo = false }) {
  const [failed, setFailed] = useState(false);
  return src && !failed ? <img src={src} alt={logo ? `${name} logo` : ""} loading="lazy" onError={() => setFailed(true)} />
    : logo ? <span className="mag-flutter-initials" aria-hidden="true">{name.slice(0, 2)}</span> : null;
}
export default function MagazineFlutter({ items = [], publicationId, presentation = getFlutterPresentation({}) }) {
  const valid = items.filter(item => isFlutterItem(item, publicationId));
  if (!valid.length) return null;
  return <section className="mag-flutter" aria-labelledby="flutter-heading">
    <div className="mag-flutter-intro"><h2 id="flutter-heading">{presentation.title}</h2><p style={{ whiteSpace: "pre-line" }}>{presentation.explanation}</p></div>
    <FlutterCarousel>
      {valid.map(item => <a className="mag-flutter-item" href={item.article.url} key={item.sourcePublication.id} data-source-publication={item.sourcePublication.id}>
        <div className="mag-flutter-thumbnail"><FlutterImage src={item.article.imageUrl} name={item.sourcePublication.name} /></div>
        <div><div className="mag-flutter-identity"><FlutterImage src={item.sourcePublication.logoUrl} name={item.sourcePublication.name} logo /><strong>{item.sourcePublication.name}</strong></div>
          <p className="mag-flutter-author">By {item.article.authorName}</p><h3>{item.article.headline}</h3></div>
      </a>)}
    </FlutterCarousel>
  </section>;
}
